import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { PersonService } from 'src/app/shared/services/person.service';
@Component({
  selector: 'app-notificacoes',
  templateUrl: './notificacoes.component.html',
  styleUrls: ['./notificacoes.component.css'],
})
export class NotificacoesComponent {
  //Icones
  faArrowRight = faArrowRight;
  notificacoes: any;
  totalItems: number = 0;
  itemsPerPage: number = 0
  page: string = '0';
  //VARIÁVEIS PAGINAÇÃO
  tamanhoLista: number = 0;
  itensPorPagina: any = 5;
  paginaAtual: any = 1;
  loading: boolean = true;
  constructor(private personService: PersonService, private router: Router) {
    this.personService.GetListUserNotifications().subscribe(
      (res: any) => {
        this.notificacoes = res;
        this.loading = false;
      });
    this.inicializarLista();
  }
  inicializarLista() {
    this.totalItems = 4;
    this.itemsPerPage = 4;
    this.page = '1';
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.itensPorPagina = quantidade;
    this.getItensDaPagina();
  }
  redirecionar(prop: any) {
    if(prop == 'boleto'){
      this.router.navigate(['/' + prop], { queryParams: { productId: 1 } });
    }else{
      this.router.navigate(['/' + prop]);
    }
  }
  getItensDaPagina(): any[] {
    const startIndex = (this.paginaAtual - 1) * this.itensPorPagina;
    const endIndex = startIndex + this.itensPorPagina;
    return this.notificacoes.slice(startIndex, endIndex);
  }
}
